import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import UserContext from '~/context/common/UserContext';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import useVehicleNotifyStatus from '~/hooks/vdp/cta/useVehicleNotifyStatus';
import useHasVehicleNotifyStatus from '~/hooks/vdp/useHasVehicleNotifyStatus';
import { getUser } from '~/selectors';

export default function useSendSoftNotify() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isInitialized } = useContext(UnlockTimerContext);
  const { availability } = useSelector(getUser);
  const { favorites } = useContext(UserContext);
  const vehicleNotifyStatus = useVehicleNotifyStatus();
  const hasVehicleNotifyStatus = useHasVehicleNotifyStatus();

  useEffectOnce(
    () => {
      trackEvent('Loaded Notify VDP', { status: vehicleNotifyStatus });
    },
    [trackEvent, vehicleNotifyStatus],
    Boolean(
      isInitialized &&
        availability.isLoaded &&
        favorites.isLoaded &&
        hasVehicleNotifyStatus
    )
  );
}
